import subscription from "@/services/subscription";
import customer from "@/services/customer";
import { getFilterQueryStringWithoutArray } from "@/helpers/helper.js";
import router from '@/router/index';

const getDefaultState = () => {
  return {
    subscriptions: [],
    subscriptionByCusOrg: null,
  };
};

const state = getDefaultState();

const getters = {
  getSubscriptions: (state) => state.subscriptions,
  getSubscriptionByCusOrg: (state) => state.subscriptionByCusOrg,
};

const mutations = {
  ["SET_SUBSCRIPTIONS"](state, data) {
    state.subscriptions = data;
  },
  ["SET_SUBSCRIPTION_BY_CUS_ORG"](state, data) {
    state.subscriptionByCusOrg = data;
  },
};

const actions = {
  fetchSubscriptions: async ({ commit, dispatch }, payload = {}) => {
    try {
      commit("SET_SUBSCRIPTIONS", []);
      const queryString = getFilterQueryStringWithoutArray(payload);
      return subscription.getSubscriptions(queryString).then(async (res) => {
        if (res?.data) {
          const options = await Promise.all(
            res.data.map(async (item) => {
              const options = await dispatch("fetchSubscriptionOptions", {
                subscription_id: item.subscription_id,
              });
              item.options = options;
              return item;
            }),
          );
          commit("SET_SUBSCRIPTIONS", options);
        }
        return res;
      });
    } catch (err) {
      const msg = "Failed to fetch subscriptions. Please try again.";
      dispatch("showToast", {
        class: "bg-danger text-white",
        message: msg,
      });
      console.error(err);
      return err;
    }
  },

  fetchPartnerSubscriptionTypes: async ({ commit, dispatch }) => {
    try {
      return subscription.getPartnerSubscriptionTypes().then(async (res) => {
        if (res?.data) {
          const options = res.data?.subscriptions;
          commit("SET_SUBSCRIPTIONS", options);
        }
        return res;
      });
    } catch (err) {
      const msg = "Failed to fetch partner subscription types. Please try again.";
      dispatch("showToast", {
        class: "bg-danger text-white",
        message: msg,
      });
      console.error(err);
      return err;
    }
  },
  fetchSubscriptionOptions: async ({ dispatch }, payload = {}) => {
    try {
      const queryString = getFilterQueryStringWithoutArray(payload);
      return subscription.getSubscriptionOptions(queryString).then((res) => {
        return res.data;
      });
    } catch (err) {
      const msg = "Failed to fetch subscription options. Please try again.";
      dispatch("showToast", {
        class: "bg-danger text-white",
        message: msg,
      });
      console.error(err);
      return err;
    }
  },
  updatePartnerSubscription: async ({ dispatch }, payload = {}) => {
    return subscription
      .updatePartnerSubscription(payload)
      .then((res) => {
        return res;
      })
      .catch((err) => {
        const msg = "Failed to update partner subscription. Please try again.";
        dispatch("showToast", {
          class: "bg-danger text-white",
          message: msg,
        });
        console.error(err);
        return err;
      });
  },
  fetchPartnerSubscription: ({ dispatch, commit }, cus_org_id) => {
      commit("SET_CUS_ORG_SUB_OPTS", []);
      commit("SET_LOADER", true);
      return customer.fetchCusOrgSubOptByID(cus_org_id).then((res) => {
        commit("SET_LOADER", false);
        if (res?.data) {
          commit("SET_CUS_ORG_SUB_OPTS", res.data);
        }
        return res;
      }).catch((err) => {
      const msg = "Failed to fetch partner subscription. Please try again.";
      dispatch("showToast", {
        class: "bg-danger text-white",
        message: msg,
      });
      console.error(err);
      return err;
    });
  },
  updatePartnerSubscription: ({ dispatch, commit }, payload = {}) => {
    commit("SET_LOADER", true);
    return subscription
      .updatePartnerSubscription(payload)
      .then((res) => {
        commit("SET_LOADER", false);
        dispatch("showToast", {
          class: "bg-success text-white",
          message: "Partner subscription updated successfully.",
        });
        router.push("/partner-list");
        return res;
      })
      .catch((err) => {
        commit("SET_LOADER", false);
        const msg = "Failed to update partner subscription. Please try again.";
        dispatch("showToast", {
          class: "bg-danger text-white",
          message: msg,
        });
        console.error(err);
        return err;
      });
  },
  fetchSubscriptionByCusOrg: ({ dispatch, commit }, cus_org_id) => {
    commit("SET_LOADER", true);
    commit("SET_SUBSCRIPTION_BY_CUS_ORG", null);
    return subscription
      .getSubscriptionByCusOrg(cus_org_id)
      .then((res) => {
        commit("SET_LOADER", false);
        commit("SET_SUBSCRIPTION_BY_CUS_ORG", res.data);
        return res;
      })
      .catch((err) => {
        commit("SET_LOADER", false);
        const msg = "Failed to fetch subscription. Please try again.";
        dispatch("showToast", {
          class: "bg-danger text-white",
          message: msg,
        });
        console.error(err);
        return err;
      });
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
